import { DemoChatView } from 'features/demo-chat';

const DemoChatPage = () => (
  <div className="flex min-h-0 flex-1 flex-col">
    <DemoChatView />
  </div>
);

export default DemoChatPage;
